import React, { FC } from "react";
import { RouteComponentProps } from "react-router";
import SecurityUsersListComponent from "go-security/components/Organization/User/UsersList";

const OrganizationSettingsUsersPage: FC<RouteComponentProps> = (props) => {
	return (
		<div className="content">
			<SecurityUsersListComponent />
		</div>
	);
};
export default OrganizationSettingsUsersPage;
